export enum ElectronicDocumentType {
  Application = 1,
  DotationAgreement = 2,  
  ApplicationAttachment = 3,
  PositiveDecision = 4,
  NegativeDecision = 5,
  AdditionalDecision = 6,
  CancellationDecision = 7,
  AdditionalAttachmentGroup = 8
}

export const electronicDocumentType = {
    1: { label: 'Paraiška', title: '' },
    2: { label: 'Dotacijos sutartis', title: '' },   
    3: { label: 'Paraiškos priedas', title: '' },
    4: { label: 'Teigiamas sprendimas', title: '' },
    5: { label: 'Neigiamas sprendimas', title: '' },
    6: { label: 'Papildomas sprendimas', title: '' },
    7: { label: 'Sutarties nutraukimo sprendimas', title: '' },
    8: { label: 'Papildomų dokumentų grupė', title: '' }
  
};
